export default __webpack_public_path__ + "static/media/Default.2132ab24.svg";